import {DataFetcher} from '@aboutyou/data-fetcher';
import {RouterErrorHandler} from '@aboutyou/router';
import React from 'react';
import {View, useCustomPageMetadata} from './CustomPageMetadata';

/**
 * Renders all meta information and handles basic tracking events of the CustomPage. This component is also responsible for redirects and 404 handling.
 */
export const AboutUsPageMetadata: React.FC<{
  pageId?: number;
}> = props => {
  // first we get data and then we check if redirect
  const request = useCustomPageMetadata({pageId: props.pageId});
  let redirectUrl: string | undefined;

  if (request.data?.meta.type?.$case === 'redirectUrl') {
    redirectUrl = request.data.meta.type.redirectUrl.url;
  }

  return (
    <DataFetcher
      request={useCustomPageMetadata({
        pageId: props.pageId,
        customFullUrl: redirectUrl,
        disabled: !redirectUrl,
      })}
      Error={RouterErrorHandler}
      View={View}
      viewProps={props}
    />
  );
};
